module.exports = __webpack_public_path__ + "static/media/pipeten_active_arbeitsmittel_true.746c1aab.jpg";